import type { RouteHandle } from 'src/root';
import type { LoaderFunctionArgs } from 'react-router';
import type { ServerRendered } from 'src/server/catalog.server';

import { useLoaderData } from 'react-router';

import { useSession } from 'src/hooks/useSession';

import { isWideRequest } from 'src/utils/device';

import { Home } from 'src/screens/Home';
import { loadCatalog } from 'src/server/catalog.server';

import { ServerAnswers } from 'src/components/ServerAnswers';

export const handle: RouteHandle = { serverRendered: true };

/** The sale catalog, asked of the api by the server for the page it renders. */
export async function loader({ request, params }: LoaderFunctionArgs) {
  return loadCatalog({
    request,
    vertical: 'buy',
    makeSlug: params.make,
    modelSlug: params.model,
    wide: isWideRequest(request),
  });
}

/** Every later visit is the browser's own: the screen asks the api itself, as it always did. */
export const clientLoader = () => null;

export default function BuyRoute() {
  const rendered = useLoaderData() as ServerRendered | null;
  const { isLoggedIn } = useSession();

  return (
    <ServerAnswers rendered={rendered}>
      {/* Soft-migration nudge: only for visitors with no account session. */}
      <Home showRegisterBanner={!isLoggedIn} />
    </ServerAnswers>
  );
}
